<template>
    <div
        id="v-categories"
        class="c-categories-filter"
        v-if="isCreated"
        v-cloak
        ref="root"
    >
        <div v-if="selectedCategoryId" class="c-categories-filter__back">
            <button
                class="c-link c-link--secondary"
                v-if="showBackButton"
                @click.prevent="back"
                :title="backButtonName"
            >
                <i class="ico ico-arrow-left is-on-left"></i>{{ backButtonName }}
            </button>
        </div>

        <div class="c-subcategories__list">
            <a
                v-for="category in categories" v-bind:key="category.id"
                :href="category.link"
                :title="category.menu_name ? category.menu_name : category.name"
                :class="{
                    'c-btn': true,
                    'is-active': category.id == selectedCategoryId,
                }"
                @click.prevent="change(category.id)"
            >
                <div class="is-image">
                    <img class="c-img" :src="projectThumbnail(category.custom_menu_image ? category.custom_menu_image : category.image, 'category-icon')" :alt="category.name" />
                </div>

                <div class="is-name">
                    {{ category.name }}
                </div>

                <i class="ico ico-arrow-right cxs-is-visible"></i>
            </a>
        </div>
    </div>
</template>

<script>
import CategoriesFilter from 'FrontendComponents/CategoriesFilter';
import { thumbnail } from 'Functions/thumbnail';

export default {
    name: 'CategoriesFilter',
    extends: CategoriesFilter,
    methods: {
        projectThumbnail: thumbnail
    },
    computed: {
        backButtonName() {
            if (!this.selectedCategory) {
                return '';
            }

            if (this.actualView == 'siblings' && this.parent) {
                return this.parent.name;
            }

            return this.selectedCategory.name;
        },
    },
};
</script>